<template>
    <v-app >
        <v-app-bar
                                         
            color="primary"
            dark
            absolute
            hide-on-scroll
            scroll-target="#scroll-target"
        >
            <div class="appbar-logo ml-3 flex-grow-0">
                <v-img
                    alt="School Logo"
                    contain
                    src="../../assets/logo.png"
                    transition="scale-transition"
                    width="40"
                />
            </div>

            <v-toolbar-title class="appbar-title ml-3 white--text">
                {{  schoolName }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <div class="appbar-actions pr-3">
                <div class="term-badge">
                    <span>Student ID: {{ studentId }} </span>
                </div>
            </div>

            <v-tooltip 
                bottom
                color="primary"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-avatar                
                        color="secondary"
                        class="mr-6 d-none d-sm-flex"
                        size="36"                
                        v-bind="attrs"
                        v-on="on"
                                       
                    >
                        <span class="primary--text">{{ userInitials }}</span>
                    </v-avatar>
                </template>
                {{ userName }}
            </v-tooltip>    

            <logout
                class="d-none d-md-flex"
            ></logout>

            <v-app-bar-nav-icon
                class="d-flex d-md-none"
                @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>          

        </v-app-bar>              
 
        <v-main>            
            <v-sheet                
                id="scroll-target"
                height="100vh" 
                class="overflow-y-auto grey lighten-5"
            >  
                <v-card
                    v-if="showMenu"
                    width="150"
                    id="speed-dial"
                    flat
                    color="grey lighten-5"
                    class="d-none mt-10 ml-4 d-md-flex flex-column pt-2"
                >
                    <v-speed-dial
                        v-model="fab"                        
                        direction="bottom"
                        transition="slide-y-reverse-transition"
                        class="d-none d-md-flex align-start"
                    >
                        <template
                            v-slot:activator
                        >
                            <v-fab-transition>
                                <v-btn                                    
                                    v-model="fab"
                                    color="primary"
                                    fab
                                >
                                    <v-icon v-if="fab">
                                        mdi-close
                                    </v-icon>
                                    <v-icon v-else>
                                        mdi-menu
                                    </v-icon>
                                </v-btn>
                            </v-fab-transition>    
                        </template>

                        <v-btn
                            v-for="(item, index) in getNavigationMenus"
                            :key="index"                            
                            small
                            color="primary"
                            text
                            class="ml-4 pa-0"
                            :to="item.route"                            
                        >
                            <v-avatar 
                                color="primary"
                                size="24"
                                class="mr-2"
                            >
                                <v-icon 
                                    small 
                                    color="white"                                   
                                >
                                    {{ item.icon }}
                                </v-icon>
                            </v-avatar>
                            {{ item.title }}
                        </v-btn>

                    </v-speed-dial>
                    <div
                        v-if="!fab"
                        class="caption mt-3 d-flex ml-3"
                        style="position:relative"
                    >
                        Menu
                    </div>
                </v-card>
                
                <v-container 
                    fluid
                    class="mt-16 pt-10 grey lighten-5"                    
                >
                    <slot></slot>
                </v-container>                    
            </v-sheet>
        </v-main>
        
        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>

         <v-navigation-drawer
            v-if="drawer"
            v-model="drawer"
            absolute
            bottom
            temporary
        >
            <v-list
                nav                    
            >
                <v-list-item-group
                    v-model="group"
                    active-class="primary--text"
                    color="primary"
                >
                    <v-list-item
                        v-for="(item, index) in navigationMenus"
                        :key="index"
                        :to="item.route"
                    >
                        <v-list-item-icon>
                            <v-icon>
                                {{ item.icon }}
                            </v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            {{ item.title }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        
        </v-navigation-drawer>

    </v-app>
</template>

<script>
import Logout from '../auth/Logout';
import { mapGetters } from 'vuex';

export default {
    name: 'App',

    components: {    
        Logout,
        
    },
   
    data: () => ({       
        drawer: false, 
        navigationMenus: [
            {title: "Logout", icon: "mdi-logout", route: '/logout'},
        ],
        group: null,        
        fab: false,
        user: {},      
    }),

    watch: {
        group () {
            this.drawer = false;
        }
    },
 
    computed: {
        ...mapGetters({
            schoolName: 'form/getSchoolName',
            overlay: 'auth/getOverlay',
            userInitials: 'auth/getUserInitials',
            userName: 'auth/getUserName',
            studentId: 'auth/getStudentId',                         
        }),

        showMenu () {
            if(this.$route.name == 'dashboard') return false;
            else return true;
        },

        getNavigationMenus () {
            return this.navigationMenus.filter(value => {
                if(value.route != this.$route.path) return value;
            })
        }
        
    },

    methods: {
       //
    },

  
};
</script>

<style scoped>
    ::v-deep .v-list-item.v-list-item--link.theme--light{
        border-left: 0px;
    }

    ::v-deep #speed-dial {
        position: fixed;
        top: 64px;
    }

    ::v-deep .v-speed-dial__list{
        align-items: start;
    }

     /* ── App Bar ─────────────────────────────────────────────────── */
    .appbar-logo {
    width: 60px;
    height: 50px;
    border-radius: 10px;
    background: rgba(255, 255, 255);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    /* flex-shrink: 0; */
    }
    
    .appbar-title {
    font-size: 13.5px !important;
    font-weight: 600 !important;
    color: white !important;
    letter-spacing: 0.9px !important;
    }
 
    .appbar-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    }
    
    .term-badge {
    display: flex;
    align-items: center;
    gap: 5px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 20px;
    padding: 4px 10px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    }
    
    .user-avatar {
    background: rgba(255, 255, 255, 0.22) !important;
    border: 1.5px solid rgba(255, 255, 255, 0.4) !important;
    cursor: pointer;
    font-weight: 700;
    font-size: 13px;
    color: white !important;
    }
    
    .logout-btn {
    color: rgba(255, 255, 255, 0.85) !important;
    font-size: 12px !important;
    text-transform: none !important;
    letter-spacing: 0 !important;
    }
 
    /* ── Main ────────────────────────────────────────────────────── */
    .main-bg {
    background: #F0F2F8 !important;
    }
    
    /* ── Welcome Header ──────────────────────────────────────────── */
    .welcome-header {
    background: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    padding: 18px 28px;
    }
    
    .welcome-eyebrow {
    margin: 0 0 2px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    color: #9FA8DA;
    }
 
    .welcome-heading {
    margin: 0;
    font-size: 20px;
    font-weight: 500;
    color: #1A237E;
    }
    
    .welcome-name {
    font-style: italic;
    color: #5C6BC0;
    font-weight: 400;
    }
    
    /* ── Dashboard Grid ──────────────────────────────────────────── */
    .dashboard-container {
    padding: 20px 20px;
    }
    
    .section-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1.4px;
    color: #9E9E9E;
    margin: 0 0 16px;
    }
</style>


